export default __webpack_public_path__ + "static/sweet-potato-76fe7077d18aee4a86e133d66cc8eac9.png";